import { fetchAuthSession } from 'aws-amplify/auth';

export const getJwt = async () => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken;

  if (!idToken) {
    throw new Error('Unauthorized');
  }

  return idToken;
};
